import React, { Component  } from "react";
import ReactDOM from "react-dom";
import Activity from "../components/activity";
import apiConst from '../../../constants/const';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  editActivityAction,
  changesInActivityAction,
  setActivityErrAction,
  deleteActivityAction,
  addActivityAction,
  changeActivityAction,
  actErrorAction,
  loadingWorkdayAction,
  changeWorkdayActivityLogs,
  setDeadheadWarningAction
} from "../actions/index";
import { Pagination, constants, KeolisSpinner } from './common/commonExport';
import ActivitiesComp from '../components/activities';
import { miscActivity } from '../const';
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import Select from "react-simple-select";
import moment from "moment";

class Activities extends React.Component {
  constructor(props) {
    super(props);
    this.isFirstLoading = true;
      this.showtotalHOS = false;
      let workday = localStorage.getItem('route') == constants.FRA_REPORT ? {workday: props.defaultWorkday} : props.workday;
    
    this.state = {
      isAdd: false,
      workday: workday,
      series_14_change:false,
      showIsSeriesGreater14:true,
      prevTimeOffError:'',
      prevDutyTimeOffDays:0,
      prevDutyTimeOffHours:0,
      prevDutyTimeOffMinutes:0
    }
  }

  componentWillReceiveProps(props){
      
    let workday = localStorage.getItem('route') == constants.FRA_REPORT ? {workday: props.defaultWorkday} : props.workday;
    if(this.props.isResetWorkday != props.isResetWorkday)
    {
      this.setState({workday: workday});
    } 
  }



  scrollToBottom() {
    if (this.added) {
      setTimeout(
        function () {
          const scrollContainer = ReactDOM.findDOMNode(
            this.scrollContainer
          );
          var parentHt = scrollContainer.offsetHeight;
          var tblHt = scrollContainer.firstElementChild.offsetHeight;
          scrollContainer.firstElementChild.style.marginTop = parentHt - tblHt + "px";
          scrollContainer.scrollToBottom = scrollContainer.scrollHeight;

          var scrollBar = scrollContainer.children[1].children[0].offsetHeight;
          scrollContainer.children[1].children[0].style.marginTop = parentHt - scrollBar + 20 + "px";
        }.bind(this),
        5
      );
    }
  }

  checkTime(time1, time2, time3) {
    var isInValid = false;
    if (time1 > time2 && time1 < time3) {
      isInValid = true;
    }
    return isInValid;
  }
  convertRawTimeToMinutes(time) {
    if (!(time && time != ""))
      return 0;
    var hoursAndMinutes = time.split(" ")[0];
    var hours = parseInt(hoursAndMinutes.split(":")[0], 10);
    var minutes = parseInt(hoursAndMinutes.split(":")[1], 10);
    var h = hours,
      m = 0;
    m = h * 60 + minutes;
    return m;
  }

  convertRawHOSToMinutes(time) {
    if (!(time && time != ""))
      return 0;
    var hoursAndMinutes = time.split(" ")[0];
    var hours = parseInt(hoursAndMinutes.split("h")[0], 10);
    var minutes = parseInt(hoursAndMinutes.split("h")[1], 10);
    var h = hours,
      m = 0;
    m = h * 60 + minutes;
    return m;
  }

  convertTimeToMinutes(time) {
    var hoursAndMinutes = time.split(" ")[0];
    var hours = parseInt(hoursAndMinutes.split(":")[0], 10);
    var minutes = parseInt(hoursAndMinutes.split(":")[1], 10);
    var h = hours,
      m = minutes;
    var timeString = time.split(" ")[1].toUpperCase();
    if (timeString === "PM") {
      if (hours === 12) {
        h = 12;
      }
      if (hours < 12) {
        h = hours + 12;
      }
    } else {
      if (hours === 12) {
        h = 0;
      }
    }
    m = h * 60 + minutes;
    return m;
  }
  getError() {
    return this.errorType;
  }
  validateTime(time, activity, isItEndTime) { // check to see if selected activity time is valid or not
    var workday = this.state.workday.workday,
      isInValidTime = false,
      extrTime = 0;
    this.errorType = 'Start time is conflicting with existing activity';
    if (isItEndTime === true) {
      this.errorType = 'End time is conflicting with existing activity '
      extrTime = this.getRawTime(activity.dty_act_end_time_raw);
    } else extrTime = this.getRawTime(activity.dty_act_start_time_raw);
    var dutyActivities = workday.duty_activity,
      selectedStartTime = this.convertRawTimeToMinutes(activity.dty_act_start_time_raw),
          selectedEndTime = this.convertRawTimeToMinutes(activity.dty_act_end_time_raw);
    for (var i in dutyActivities) {
      if (activity.duty_activity_key !== dutyActivities[i].duty_activity_key) {
        if (!dutyActivities[i]["isMisc"]) {
          var startTime = this.convertRawTimeToMinutes(dutyActivities[i].dty_act_start_time_raw);
          endTime = this.convertRawTimeToMinutes(dutyActivities[i].dty_act_end_time_raw);
          if (!dutyActivities[i].isDeleted === true && !dutyActivities[i]["isMisc"])
            isInValidTime = this.checkTime(this.convertTimeToMinutes(time) + extrTime, startTime, endTime);
          if (isInValidTime === true) {
            break;
          } else {
            for (var a in dutyActivities) {
              if (!dutyActivities[a].isDeleted === true && !dutyActivities[a]["isMisc"])
                if (activity.duty_activity_key !== dutyActivities[a].duty_activity_key) {
                  var startTime = this.convertRawTimeToMinutes(dutyActivities[a].dty_act_start_time_raw);
                  var endTime = this.convertRawTimeToMinutes(dutyActivities[a].dty_act_end_time_raw);
                  var sTime = this.convertTimeToMinutes(time) + extrTime;
                  isInValidTime =
                    startTime === selectedStartTime &&
                    endTime === selectedEndTime &&
                    selectedStartTime !== selectedEndTime;
                  if (isInValidTime === true) break;
                  isInValidTime = this.checkTime(
                    endTime,
                    selectedStartTime,
                    selectedEndTime
                  );
                  if (isInValidTime === true) {
                    break;
                  }
                  isInValidTime = this.checkTime(
                    startTime,
                    selectedStartTime,
                    selectedEndTime
                  );
                  if (isInValidTime === true) {
                    break;
                  }
                } else {
                    if (selectedStartTime > selectedEndTime && activity.dty_act_name.trim().toLowerCase() !== 'sign-off') {
                        this.errorType = (isItEndTime === true) ? 'End time cannot be less than start time' : 'Start time cannot be greater than end time';
                        return true;
                    }                   
                    

                }
            }
            if (isInValidTime === true) {
              break;
            }
          }
        } else {
          isInValidTime = false;
        }
      } else {
          if (selectedStartTime > selectedEndTime && activity.dty_act_name.trim().toLowerCase() !== 'sign-off') {
              this.errorType = (isItEndTime === true) ? 'End time cannot be less than start time ' : 'Start time cannot be greater than end time';
              return true;
          }       
      }
    }
    return isInValidTime;
  }
  checkValidDate(date){
    let work_day =  moment(this.state.workday.workday.wdy_date,"MM/DD/YYYY");
    var selectedDate = moment(date, "MM/DD/YYYY");
    var result = selectedDate.diff(work_day, 'days');
    return result == 0 || result == 1;
  }

  checkValidLimboActivity(dutyActivities)
  {
    let isError=false;
    let limboActivities = dutyActivities.filter((d) => {
      let act_name = d.dty_act_name_updated?d.dty_act_name_updated : d.dty_act_name
      return act_name.trim().toLowerCase().includes("limbo") && !d.isDeleted;
    });
    let coveredService = dutyActivities.filter((act) =>{
    let actName = act.dty_act_name_updated?act.dty_act_name_updated.trim():act.dty_act_name.trim()
   return constants.HOS_COVERED_SERVICE.indexOf(actName)> -1 && !act.isDeleted ;
    })
     
    


    if(Array.isArray(limboActivities) && limboActivities.length > 0){
     // check for more than one limbo 
     if(limboActivities.length>1)
     {
      this.errorType ="Only one Limbo activity allowed."
      isError = true;
     }
     //check limbo is only activity
     if((limboActivities.length==1 && dutyActivities.length == 1) || ((limboActivities.length >0) && (coveredService.length ==0)))
     {
      this.errorType ="Limbo cannot be the only Activity.It should be after a covered service."
      isError = true;
     }
     //limbo should have a covered service and come after a covered service    
      if ((limboActivities.length >0) && ((coveredService.length >0) ))
      {
        let act_start_date = coveredService[0].dty_act_start_date; 
        let act_limbo_date = limboActivities[0].dty_act_start_date; 
        let act_start_time = coveredService[0].dty_act_start_time_updated ? coveredService[0].dty_act_start_time_updated : coveredService[0].dty_act_start_time;
        let act_limbo_time = limboActivities[0].dty_act_start_time_updated ? limboActivities[0].dty_act_start_time_updated : limboActivities[0].dty_act_start_time;
        let start =  moment(act_start_date+' '+act_start_time, 'MM/DD/YYYY hh:mm A');
        let end =  moment(act_limbo_date+' '+act_limbo_time, 'MM/DD/YYYY hh:mm A');
        let diff = end.diff(start, 'minutes');

        if(diff < 0 || (coveredService[0].duty_activity_key > limboActivities[0].duty_activity_key))
        {
          this.errorType ="Limbo Activity should be after a covered service."
          isError = true;
        }  
      
      } 


    return isError;
    }
    
  }

  validateHoslogTime(activity, propName){
    var workday = this.state.workday.workday
    var isInValidTime = false;
    var dutyActivities = workday.duty_activity;
    let curr_act_date =  activity[`dty_act_${propName}_date`] ? activity[`dty_act_${propName}_date`] : workday.wdy_date,
      curr_act_time = activity[`dty_act_${propName}_time_updated`] ? activity[`dty_act_${propName}_time_updated`] : activity[`dty_act_${propName}_time`];

       
    if(!this.checkValidDate(curr_act_date)){
      isInValidTime = true;
      this.errorType = `${propName} date should either ${moment(workday.wdy_date,"MM/DD/YYYY").format("MM/DD/YYYY")} or ${moment(workday.wdy_date,"MM/DD/YYYY").add(1, 'days').format("MM/DD/YYYY")}`;
      return isInValidTime;
    }
    var curr_activity_datetime =  moment(curr_act_date+' '+curr_act_time, 'MM/DD/YYYY hh:mm A');
    var opp_propName = propName == "start" ? "end" : "start";
    let curr_act_date_opp =  activity[`dty_act_${opp_propName}_date`] ? activity[`dty_act_${opp_propName}_date`] : workday.wdy_date,
      curr_act_time_opp = activity[`dty_act_${opp_propName}_time_updated`] ? activity[`dty_act_${opp_propName}_time_updated`] : activity[`dty_act_${opp_propName}_time`];
    var curr_activity_datetime_opp = moment(curr_act_date_opp+' '+curr_act_time_opp, 'MM/DD/YYYY hh:mm A');
    var diff_curr_time = curr_activity_datetime.diff(curr_activity_datetime_opp);
    if((propName == "end" && diff_curr_time <= 0) || (propName == "start" && diff_curr_time >= 0)){
      isInValidTime = true;
      this.errorType = propName == "end" ? "End time cannot be less than start time" : "Start time cannot be greater than end time";
      return isInValidTime;
    }
   
    for(var i = 0; i < dutyActivities.length; i++){
      let act = dutyActivities[i];
      if(activity.duty_activity_key !== act.duty_activity_key && !act.isDeleted){
        let act_start_date = act.dty_act_start_date ? act.dty_act_start_date : workday.wdy_date,
          act_end_date = act.dty_act_end_date ? act.dty_act_end_date : workday.wdy_date,
          act_start_time = act.dty_act_start_time_updated ? act.dty_act_start_time_updated : act.dty_act_start_time,
          act_end_time = act.dty_act_end_time_updated ? act.dty_act_end_time_updated : act.dty_act_end_time
        let start =  moment(act_start_date+' '+act_start_time, 'MM/DD/YYYY hh:mm A');
        let end =  moment(act_end_date+' '+act_end_time, 'MM/DD/YYYY hh:mm A');
        if(curr_activity_datetime.isBetween(start,end) || (propName == "end" && curr_activity_datetime.isSame(end)) ||
                  (propName == "start" && curr_activity_datetime.isSame(start)))
        {
          isInValidTime = true;
          this.errorType = `${propName} time is conflicting with existing activity`;
        }
        else if((propName == "end" && start.isBetween(curr_activity_datetime_opp,curr_activity_datetime)) 
          || (propName == "start" && end.isBetween(curr_activity_datetime,curr_activity_datetime_opp)))
        {
          isInValidTime = true;
          this.errorType = `${propName} time is conflicting with existing activity`;
        }
       

      }
      if(i==0)
      {
        this.onChangeActivityUpdatePreviousTimeOffDuty(workday);
      }
      isInValidTime = this.checkValidLimboActivity(dutyActivities);

      if (isInValidTime === true) {
        break;
      }
    }
    return isInValidTime;
  }

  addNewActivity(addedtype = "") {
    this.setState({isAdd: true});
    this.added = true;
    this.props.onAddActivity(addedtype);
    this.props.onActErr(false, true);

    setTimeout(function () {
      if (document.querySelectorAll('.scrollarea-content')[1] && document.querySelectorAll('.scrollarea-content')[1].scrollHeight > 500) {
        let scrollBottom = document.querySelector('.scrollarea .scrollbar-container.vertical .scrollbar'),
          contentBottom = document.querySelectorAll('.scroll-bar')[1];
        if (scrollBottom) {
          scrollBottom.style.marginTop = scrollBottom.offsetParent.offsetHeight - scrollBottom.offsetHeight + "px";
        }
        contentBottom.children[0].style.marginTop = contentBottom.offsetHeight - contentBottom.children[0].offsetHeight + "px"
      }
    }, 100);
  }

  renderAddButton() {
    var workday = this.state.workday.workday;
    var validWorkday = this.props.validWorkday;
    var addingWorkday = this.props.authDetails.impersonateUserId>0 && apiConst.isImpersonateEditAllow && 
      (workday.AllowAmendmentEdit == '0' || workday.AllowAmendmentEdit == undefined);
     let isAdminShowAdd = (this.props.authDetails.isSystemAdmin != undefined && this.props.authDetails.isSystemAdmin == true && this.props.isEdit==true)
     let isOFFDay= workday.duty_activity && (workday.duty_activity.length ==0 || workday.duty_activity[0].isNew);

    if (this.props.modalName == "Certify_Modal" || this.props.addingWorkday) {
      return (
          <button className={"btn btnWidth add-button " + (addingWorkday && !isAdminShowAdd? "hidden" : ((isOFFDay || workday.dutyActivityStatus == 'N') && validWorkday.validWorkday) || workday.activitiesEditMode || isAdminShowAdd? '' : 'hidden')}
          disabled={(isOFFDay || workday.dutyActivityStatus == 'N')? false : (this.props.activityErr || this.props.postInProgress
            || !workday.activitiesEditMode) && !isAdminShowAdd}
          onClick={() => this.addNewActivity()}>Add
        </button>
      );
    }
    return "";
  }
  getRawTime(time) {
    try {
      var hour = parseInt(time.split(":")[0]);
      if (hour > 23) {
        return 24 * 60;
      } else return 0;
    } catch (error) {
      return 0;
    }
  }

  setActivityErr(key, bool) {
    this.props.setActivityErr(key, bool);
  }

  onDeleteActivity(key) {
    this.props.onDeleteActivity(key);
    this.renderWorkdayDetails();
    var duty_activity = this.state.workday.workday.duty_activity;

    if(this.props.isLogUser){
      let deadheadActivities = duty_activity.filter((d) => {
        let act_name = d.dty_act_name_updated?d.dty_act_name_updated : d.dty_act_name
        return act_name.trim().includes("Deadhead") && !d.isDeleted;
      });
      if(Array.isArray(deadheadActivities) && deadheadActivities.length > 0){
        let status,message;
        if(deadheadActivities.length == 1){
          status = true;
          message = `${deadheadActivities[0].dty_act_name.includes("from")?"Deadhead Start":"Deadhead End"} is missing.`;
        }else{
          status = false;
          message = "";
        }
        this.props.setDeadheadWarningAction(status,message);
      }
      else{
        this.props.setDeadheadWarningAction(false,'');
      }
    }
    
    var counter = 0;
    for (var activity in duty_activity) {
      if (duty_activity[activity].isErr) {
        counter += 1;
      }
    }
    if (counter > 0) {
      this.props.onActErr(false, true); // para1: errpop, para2: acterr
    } else {
      this.props.onActErr(false, false); // para1: errpop, para2: acterr
    }
  }

  getTimeOf(mins) {
    let h = parseInt(mins / 60 + '');
    let m = mins % 60;
    if (h > 23) {
      h = h % 24;
    }
    let timeString = 'AM';
    if (h > 12) {
      timeString = "PM"
    }

    if (h > 12) {
      h = h - 12;
    } else if (h === 0) {
      h = 12;
    }

    if (m < 10) {
      m = '0' + m;
    }
    return h + ':' + m + ' ' + timeString
  }
  onDeadeheadWarningHandler(status,message){
    this.props.setDeadheadWarningAction(status,message);
    }

   onEndDateChange() {
       this.showtotalHOS = true;
}

  renderActivities(defaultWorkday) {
    var workday = this.state.workday.workday;
    if (workday && Object.keys(workday).length > 0 && workday.duty_activity && Object.keys(workday.duty_activity).length > 0) {
      this.rawValue = 0;
      var activitiesObj = workday.duty_activity;
      var activitiesEditMode = workday.activitiesEditMode ? workday.activitiesEditMode : false;
      if (activitiesObj) {
        for (var a in activitiesObj) {
          if (
            this.getRawTime(activitiesObj[a].dty_act_start_time_raw) ===
            24 * 60 ||
            this.getRawTime(activitiesObj[a].dty_act_end_time_raw) === 24 * 60
          ) {
            this.rawValue = 24;
            break;
          }
        }

        if(Array.isArray(activitiesObj) && activitiesObj && activitiesObj.length > 0 && !this.props.deadheadWarning){
          let deadheadActivities = activitiesObj.filter((d) => {
            let act_name = d.dty_act_name_updated?d.dty_act_name_updated : d.dty_act_name
            return act_name.trim().includes("Deadhead") && !d.isDeleted;
          });
          if(deadheadActivities.length == 1){
            let status = true,
              message = `${deadheadActivities[0].dty_act_name.includes("from")?"Deadhead Start":"Deadhead End"} is missing.`;
            this.props.setDeadheadWarningAction(status,message);
          }
        }
        var activitiesArr = Object.keys(activitiesObj).map(function (k) {
          activitiesObj[k]["duty_activity_key"] = k;
          return activitiesObj[k];
        });

        var counter = 0;
        var changesInActivity = false;
        // checking if any changes (add/edit/delete) in any of the activities
        if (workday && Object.keys(workday.duty_activity).length > 0 && Object.keys(workday).length > 0) {
          var counter = 0;
          var duty_act = workday.duty_activity;
          for (var activity in duty_act) {
            if (
              ((duty_act[activity].isDeleted ||
              duty_act[activity].isEdited ||
              duty_act[activity].isNew) && duty_act[activity]['change']) || (this.props.isLogUser && duty_act[activity].isDeleted)
            ) {
              counter += 1;
            }
          }
          if (counter > 0 || (this.props.isLogUser && workday["change"])) {
            this.props.onChangesInActivity(true);
          } else {
            this.props.onChangesInActivity(false);
          }
        }

        let l1 = activitiesArr.length;
        let workdayToggled = this.state.workday.workdayToggled;
        let eventKey = this.props.eventKey;

        let dbActivities = this.props.dbActivities;
       
        return activitiesArr.map((duty_activity, index) => {
          if(duty_activity.isDeleted){
            return null;
          }

          return (
              <Activity workdayToggled={workdayToggled}
                  key={index} postInProgress={this.props.postInProgress}
                  duty_activity_key={duty_activity.duty_activity_key}
                  index={index}
                  id={index}
                  adjustedHOS={this.props.adjustedHOS}
                  Activity={duty_activity}
                  showAction={
                      this.props.modalName == "Certify_Modal" || this.props.addingWorkday ? true : false
                  }
                  activityEditMode={activitiesEditMode}
                  onDeleteActivity={this.onDeleteActivity.bind(this)}
                  rawValue={this.rawValue}
                  onEditActivity={this.props.onEditActivity}
                  onChangeActivity={this.props.onChangeActivity}
                  role={this.props.role.role}
                  workday={this.state.workday.workday}
                  onActErr={this.props.onActErr}
                  validateTime={this.validateTime.bind(this)}
                  dbActivities={dbActivities}
                  activityErr={this.props.activityErr}
                  loadingWorkday={this.props.loadingWorkday}
                  getError={this.getError.bind(this)}
                  setActivityErr={this.setActivityErr.bind(this)}
                  eventKey={eventKey} isHOSModal={this.props.isHOSModal}
                  isLogUser={this.props.isLogUser}
                  onAddDeadhead={this.addNewActivity.bind(this)}
                  validateHoslogTime={this.validateHoslogTime.bind(this)}
                  impersonateUserId={this.props.authDetails.impersonateUserId}
                  setDeadheadWarning={this.onDeadeheadWarningHandler.bind(this)}
                  renderWorkdayDetails={this.renderWorkdayDetails.bind(this)}
                  onEndDateChange={this.onEndDateChange.bind(this) }
            />
          );


        });
      } else {
        return <tr><td>No Activities</td></tr>;
      }
    } else if (this.props.addingWorkday) {
      return <tr><td>No Activities</td></tr>;
    } else if (!workday.duty_activity || workday.duty_activity.length <= 0) {
      return <tr><td>No Activities</td></tr>;
    } else {
      return (
        <tr>
          <td>
            <keolisSpinner />
          </td>
        </tr>
      );
    }
  }
  getTos(time) {

    if (time <= 0) {
      return "0h00";
    }
    var h = parseInt("" + time / 60);
    var m = time % 60;
    if (m > 9) {
      return h + "h" + m;
    } else {
      return h + "h" + "0" + m;
    }
  }

  getUpdatedValue(updated, initial) {
    
    if (updated && updated !== '') {
      return updated;
    }
    else return initial;
  }




  renderLogs() {
    
    const { workday } = this.state.workday;
    let role = this.props.authDetails.role;
    if (workday && role == constants.roles.EMPLOYEE_ROLE && Object.keys(workday).length > 0 && workday.wdy_certify_status == 'U' && workday.wdy_comments != 'NULL') {
      return (<div className="col-sm-5 col-md-5 activitiesMdlRight">
        <div className="activitiesContainer">
          <div className="activity-header">Comments</div>
          <div className="activitiesBody">
            {this.renderComments(workday.wdy_comments)}
          </div>
        </div>
      </div>)
    } else {
      return ("")
    }
  }
  renderWorkdayDetails() {
    
    let self = this;
    var workday = this.state.workday.workday;
    var totalHOS = "",totalTOS = "",calTotalHos="";
       if (workday && Object.keys(workday).length > 0 && workday.duty_activity && Object.keys(workday.duty_activity).length > 0) {
       if(this.props.isLogUser){
        
        var duty_activities = workday.duty_activity;
        var total_hos = 0,total_tos = 0,start_Time ='',end_Time='';

        let isCoveredService = duty_activities.filter(act => constants.HOS_COVERED_SERVICE.indexOf(act.dty_act_name_updated?act.dty_act_name_updated.trim():act.dty_act_name.trim()) > -1).length > 0;
        
        duty_activities.map((act) => {
          if(!act.isDeleted){
            let act_start_date = act.dty_act_start_date ? act.dty_act_start_date : workday.wdy_date,
            act_end_date = act.dty_act_end_date ? act.dty_act_end_date : workday.wdy_date,
            act_start_time = act.dty_act_start_time_updated ? act.dty_act_start_time_updated : act.dty_act_start_time,
            act_end_time = act.dty_act_end_time_updated ? act.dty_act_end_time_updated : act.dty_act_end_time
            let start =  moment(act_start_date+' '+act_start_time, 'MM/DD/YYYY hh:mm A');
            let end =  moment(act_end_date+' '+act_end_time, 'MM/DD/YYYY hh:mm A');
            let diff = end.diff(start, 'minutes');
            total_tos = total_tos + diff;
            let act_name_cur = act.dty_act_name_updated ? act.dty_act_name_updated : act.dty_act_name;
            if(!act_name_cur.trim().toLowerCase().includes('split break') && !act_name_cur.trim().toLowerCase().includes('deadhead from')
                  && !act_name_cur.trim().toLowerCase().includes('absence') && !act_name_cur.trim().toLowerCase().includes('limbo')){
              total_hos = total_hos + diff;
              
            }
            start_Time = start_Time == '' ? start : start.isBefore(start_Time) ? start : start_Time;
            end_Time = end_Time == '' ? end : end.isAfter(end_Time) ? end : end_Time;
          }
        });

        
        workday.wdy_working_time_hos_adjust = isCoveredService.toString().trim()==='false'? "0h00": this.getTos(total_hos);
        workday.wdy_spread_adjust = this.getTos(total_tos);
        workday.wdy_time_start = start_Time?start_Time.format("MM/DD/YYYY hh:mm A") : "";
        workday.wdy_time_end = end_Time?end_Time.format("MM/DD/YYYY hh:mm A") : "";
      }
      else{
        
        var val = workday, duty_activities = workday.duty_activity,
          max = 0,
          min = 100000,
          hos = 0;
        calTotalHos = workday.wdy_working_time_hos_adjust && workday.wdy_working_time_hos_adjust != 'NULL'
            ? workday.wdy_working_time_hos_adjust : workday.wdy_working_time_hos;
            
            totalHOS = this.showtotalTimeonDuty(workday,calTotalHos);
        totalTOS = workday.wdy_spread_adjust ? workday.wdy_spread_adjust : workday.wdy_spread;
        let isCoveredService = duty_activities.filter(act => constants.HOS_COVERED_SERVICE.indexOf(act.dty_act_name.trim()) > -1).length > 0;
        let startActivityDateTime,endActivityDateTime;       
        if (!this.isFirstLoading && this.props.isEdit || (!this.isFirstLoading && this.state.isAdd && !this.props.isEdit)) {
          for (var a in duty_activities) {
            if (!duty_activities[a].isDeleted) {
              let nonClculateArray = ["Locomotive Engineer Stipend", "Time Paid Not Worked Straight", "Time Paid Not Worked Overtime", "Diversion", "Split break", "Absence", "Abs break before", "Abs break after", "Travel"];
              let isContains = false;
              let activity = nonClculateArray.filter(function (value, index) {
                if (!isContains)
                  isContains = self.getUpdatedValue(duty_activities[a].dty_act_name_updated, duty_activities[a].dty_act_name) === value;
                return value;
              });

              let act_start_date = duty_activities[a].dty_act_start_date ? duty_activities[a].dty_act_start_date : workday.wdy_date,
                  act_end_date = duty_activities[a].dty_act_end_date ? duty_activities[a].dty_act_end_date : workday.wdy_date,
                  act_start_time = duty_activities[a].dty_act_start_time_updated ? duty_activities[a].dty_act_start_time_updated : duty_activities[a].dty_act_start_time,
                  act_end_time = duty_activities[a].dty_act_end_time_updated ? duty_activities[a].dty_act_end_time_updated : duty_activities[a].dty_act_end_time;
              
              let start =  moment(act_start_date+' '+act_start_time, 'MM/DD/YYYY hh:mm A');
              let end =  moment(act_end_date+' '+act_end_time, 'MM/DD/YYYY hh:mm A');              
              if(endActivityDateTime > end){ end = end.add(1,'days');}
              startActivityDateTime = startActivityDateTime ? startActivityDateTime: start;
              endActivityDateTime = end;                

              if (isContains === false) {
                try {

                  var time1 =
                    this.convertRawTimeToMinutes(duty_activities[a].dty_act_start_time_raw);
                  var time2 =
                    this.convertRawTimeToMinutes(duty_activities[a].dty_act_end_time_raw);
                  min = time1 < min ? time1 : min;
                  max = time2 > max ? time2 : max;                  

                
                  // if (time1 !== 0 && time2 !== 0 && isContains) hos += time2 - time1;
                } catch (error) { }
              } else {
                try {
                  var time1 =
                    this.convertRawTimeToMinutes(duty_activities[a].dty_act_start_time_raw);
                  var time2 =
                    this.convertRawTimeToMinutes(duty_activities[a].dty_act_end_time_raw);

                  if (time1 !== 0 && time2 !== 0 && max != 0) hos += time2 - time1;
                } catch (error) { }
              }
            }
          }
          let tos = max - min;
          let thos = tos - hos + (this.convertRawHOSToMinutes(workday.wdy_working_time_hos) - this.convertRawHOSToMinutes(workday.wdy_working_time));
         
          workday.wdy_working_time_hos_adjust = isCoveredService.toString().trim()==='false'? "0h00": this.getTos(total_hos);
          
          workday.wdy_spread_adjust = this.getTos(endActivityDateTime.diff(startActivityDateTime,'minutes'));
          
          workday.wdy_time_start = this.getTimeOf(min);
          workday.wdy_time_end = this.getTimeOf(max);
        } else {
          this.isFirstLoading = false;
        }
      }
      const isMenumappingConf = this.props.isFRAReport == true || this.props.authDetails.role == constants.roles.ADMIN_ROLE || 
               (this.props.authDetails.activeMenus && Array.isArray(this.props.authDetails.activeMenus) && this.props.authDetails.activeMenus.length > 0);
           let doNotShowTimeCalc = workday.IsAmendment == '0' && (workday.wdy_certify_status.trim().toUpperCase() == 'U')
               && workday.AllowAmendmentEdit == undefined ;//&& !(this.props.authDetails.role == constants.roles.ADMIN_ROLE);

              let isSeriesGreater14= workday.dty_act_series_14 && Number(workday.dty_act_series_14) > 14;
                


      return (
        <div className="workdaySummary">
        
          
          
        <div className={isSeriesGreater14 && this.state.showIsSeriesGreater14?  (
                                "errAlertDiv alert alert-danger fade in alert-dismissable alertBox"
                    ):( "animated fadeOut hidden" ) }>
              <a  onClick={() =>  this.setState({showIsSeriesGreater14:false})}  className="close" data-dismiss="alert" aria-label="close" title="close" >×</a>

                <strong>{'Warning'}!</strong> {"- The 14 day Series contains value greater than 14. Please check."}
            </div>
            
         



            
          {
            this.props.isFRAReport == true && 
              (<div><p className="amendmentText">{workday.row_num && workday.row_num != "0" ? "Amendment " + workday.row_num : "" }</p></div>)
          }
          <div className={"row" + (isMenumappingConf ? this.props.isLogUser ? '' : ' hidden' : '')}>
            <span className="bottom-content">Total HOS:</span>
            <span className="bottom-contents">
                      {
                          doNotShowTimeCalc && !this.showtotalHOS ? "" :              
              this.props.role.role == "Admin" && !this.props.isLogUser ? (
                this.props.adjustedHOS ? (
                  <span className="red">{totalHOS}</span>
                                  ) : workday.wdy_certify_status === constants.CLAIM ? (workday.wdy_working_time_hos)
                                          : (totalHOS))
                                  : (this.props.isLogUser ? this.showtotalTimeonDuty(workday,workday.wdy_working_time_hos_adjust) : totalHOS)


                      }
            </span>
          </div>
          <div className={"row" + (isMenumappingConf ? this.props.isLogUser ? ' hidden' : '':'')} >
            <span className="bottom-content">Total TOS:</span>
            <span className="bottom-contents">
              {this.props.role.role == "Admin" ? (
                this.props.adjustedHOS ? (
                  <span className="red">{totalTOS}</span>
                ) : workday.wdy_certify_status === constants.CLAIM ? (
                  workday.wdy_spread
                ) : (
                      totalTOS
                    )
              ) : (
                  totalTOS
                )}
            </span>
          </div>
        </div>
      );
    } else if (workday && !workday.duty_activity || workday.duty_activity.length <= 0) {
      return (
        <span>No Details...</span>
      );
    } else {
      return (
        <span>Loading Details...</span>
      );
    }
  }



  renderComments(comments) {
    if (comments) {
      comments = comments.split("~");
      if (comments.length > 1) {
        return comments.map(function (comment, index) {
          if (comments.length == index + 1) {
            return ('');
          } else {
            if (comment.split('^-').length > 1) {
              if (comment.split('^-')[1] != undefined && !comment.split('^-')[1].includes("undefined") && comment.split('^-')[1] != "") {
                return (
                  <span className="comment" key={index}>
                    <span className="commentBy">{comment.split('^-')[0] + " - "}</span>
                    <span>{comment.split('^-')[1]}</span>
                  </span>
                );
              } else {
                return ("");
              }
            } else {
              return (
                <span className="comment" key={index}>
                  <span className="commentBy">{comment.split('-')[0] + " - "}</span>
                  <span>{comment.split('-')[1]}</span>
                </span>
              );
            }
          }
        })
      } else {
        return comments;
      }

    }


  }

  renderCommentBox() {
    var workday = this.state.workday.workday,
      emp_full_name = workday.emp_full_name,
      emp_full_name = emp_full_name.split(" ")[1] + ' ' + emp_full_name.split(" ")[0],
      comments = workday.wdy_comments == "NULL" ? "" : workday.wdy_comments;
    return (
      <div className="cmtBox">
        <h4>Comments from {emp_full_name}: </h4>
        <div className="cmtDiv">{this.renderComments(comments)}</div>
      </div>
    );
  }
    workdayActChange(property, value) { 

    this.setState({showIsSeriesGreater14:true})   

    this.props.changeWorkdayActivityLogs(property,value);

  }


  getPreviousTimeOFDutyValue(name)
  {
     let result = 0;
    switch (name) {
    case 'inputDays':
      result = this.state.prevDutyTimeOffDays  
      break;
      case 'inputHours':
        result = this.state.prevDutyTimeOffHours
      break;
      case 'inputMinutes':
        result = this.state.prevDutyTimeOffMinutes            
     break;           
      default:
        break;
     }
  
     this.prevTimeOnChange();
     return  result;   
  }


  handlePrevTime(name,value)
  {
   let errorMsg= '';
   let totalDuration = 0;
   if(this.state.prevTimeOffError != errorMsg) this.setState({prevTimeOffError:errorMsg});
   
   if((value % 1) != 0)
   {
        errorMsg = "Please enter whole numbers";
   }

  switch (name) {
  case 'inputDays':
    if(name=='inputDays' &&( value>999 || value < 0))
    {
     errorMsg=value < 0? "Days cannot be less than 0" : "Days cannot be more than 999" ;
     
    }else{
      
      this.setState({prevDutyTimeOffDays:value});  
      totalDuration = (parseInt(value) * 24 *60) + (parseInt(this.state.prevDutyTimeOffHours)*60) + parseInt(this.state.prevDutyTimeOffMinutes);  
    }      
    break;
    case 'inputHours':
    if(name=='inputHours' &&( value < 0|| value>23))
    {
    errorMsg=value < 0? "Hours cannot be less than 0" :"Hours cannot be more than 23";
    
    }else{
      this.setState({prevDutyTimeOffHours:value}); 
      totalDuration = (parseInt(this.state.prevDutyTimeOffDays) * 24 *60) + (parseInt(value)*60) + parseInt(this.state.prevDutyTimeOffMinutes);  
     }
    break;
    case 'inputMinutes':
      if( name =='inputMinutes' && (value < 0|| value>59))
      {
       errorMsg=value < 0? "Minutes cannot be less than 0":"Minutes cannot be more than 59";
       
      }else{
      this.setState({prevDutyTimeOffMinutes:value}); 
      totalDuration = (parseInt(this.state.prevDutyTimeOffDays) * 24 *60) + (parseInt(this.state.prevDutyTimeOffHours)*60) + parseInt(value);  
    }
          
   break;
         
    default:
      break;
   }

  if(totalDuration < 480 ){errorMsg="Previous time of duty is less than 8 hours. ";}

    if(errorMsg.length > 0) this.setState({prevTimeOffError:errorMsg});

   return ;
  }


   showRelievedOfDuty(workday,releivedOfDuty)
   {
    let data =releivedOfDuty;
    let isDutyChange = workday.duty_activity.filter((a) => a.change==true|| a.isDeleted == true);
    if(workday.relieved_Of_Duty &&  workday.relieved_Of_Duty.length>0 && isDutyChange && isDutyChange.length == 0)
    {
      data = workday.relieved_Of_Duty;
    } else if(workday.relieved_Of_Duty != releivedOfDuty&& isDutyChange && isDutyChange.length > 0) {
   
      this.props.changeWorkdayActivityLogs("relieved_Of_Duty",releivedOfDuty);
    }
    return data;

   }
   showfinalRelease(workday,finalRelease)
   {
    let data =finalRelease;
    let isDutyChange = workday.duty_activity.filter((a) => a.change==true|| a.isDeleted == true);
    if(workday.final_Release &&  workday.final_Release.length>0 && isDutyChange && isDutyChange.length == 0)
    {
      data = workday.final_Release;
    } else if(workday.final_Release != finalRelease && isDutyChange && isDutyChange.length > 0 ) {
    
      this.props.changeWorkdayActivityLogs("final_Release",finalRelease);
    }
    return data;


   }
   
   showtotalTimeonDuty(workday,totalTimeonDuty)
   {
    let data =totalTimeonDuty;
    let isDutyChange = workday.duty_activity.filter((a) => a.change==true || a.isDeleted == true);
    if(workday.total_time_hos &&  workday.total_time_hos.length>0 && isDutyChange && isDutyChange.length == 0 )
    {
      data = workday.total_time_hos.toLowerCase();
    } else if(workday.total_time_hos != totalTimeonDuty && isDutyChange && isDutyChange.length > 0) {
           this.props.changeWorkdayActivityLogs("total_time_hos",totalTimeonDuty);
    }

    data = data.toLowerCase().lastIndexOf('m') > 0?data:data.trim() + 'm';

    return data;

   }



  prevTimeOnChange(e)
  {    
    let workday = this.state.workday.workday;    
    let durationString =  this.state.prevDutyTimeOffDays+'D';
    durationString += this.state.prevDutyTimeOffHours+'H';
    durationString += this.state.prevDutyTimeOffMinutes+'M';
    if( !workday.previous_Time_Off_Duty ||( workday.previous_Time_Off_Duty.toLowerCase().trim() != durationString.toLowerCase().trim() ))
    {
    this.workdayActChange("previous_Time_Off_Duty",durationString);
    }
  }

  showPreviousTimeOffDuty(workday)
  {
       
    let duration = workday.previous_Time_Off_Duty;    
    let days = 0;
    let hours=0;
    let minutes=0;
    
    if(duration.toUpperCase().indexOf('D')>0) {days = duration.substring(0,duration.toUpperCase().indexOf('D')).trim();}
    if(duration.toUpperCase().indexOf('H')>0) {hours = duration.substring(duration.toUpperCase().indexOf('D')+1,duration.toUpperCase().indexOf('H')).trim();}
    if(duration.toUpperCase().indexOf('M')>0) {minutes = duration.substring(duration.toUpperCase().indexOf('H')+1,duration.toUpperCase().indexOf('M')).trim();}
    if(this.state.prevDutyTimeOffDays != days || this.state.prevDutyTimeOffHours != hours || this.state.prevDutyTimeOffMinutes != minutes)
    { 
   
      this.setState({
      prevDutyTimeOffDays:days,
      prevDutyTimeOffHours:hours,
      prevDutyTimeOffMinutes:minutes
    }); 
    
  }

  let durationString = days > 0 ? days+'D ':'';
  durationString += hours+'H ';
  durationString += minutes+'M ';
    return durationString;

  }

  onChangeActivityUpdatePreviousTimeOffDuty(workday)
  {
   
      this.getPrevTimeOffDuty(workday);
      this.prevTimeOnChange();
  }


  getPrevTimeOffDuty(workday){

     let diff = this.props.calculatePreviousDutyTime(workday);
      if(diff== 0) return '-';
   

    if(Number.isNaN(diff)){
      return '-';
    }
    var minutes = Math.floor(diff / 60000);
    var hours = Math.floor(minutes / 60);
    minutes = minutes % 60
    var days = Math.floor(hours / 24);
    if(hours > 24)
    {
      hours = hours % 24;
    }
    let durationString = days > 0 ? days+'D ':'';
    durationString += hours+'H ';
    durationString += minutes+'M ';

    if(this.state.prevDutyTimeOffDays != days || this.state.prevDutyTimeOffHours != hours || this.state.prevDutyTimeOffMinutes != minutes)
    { 
   
      this.setState({
      prevDutyTimeOffDays:days,
      prevDutyTimeOffHours:hours,
      prevDutyTimeOffMinutes:minutes
    }); 
  }

   
    return durationString;
  }
  renderWorkDayActLogs() {
    let workday = this.state.workday.workday;
    let isOFFDay= workday.duty_activity && (workday.duty_activity.length ==0 || workday.duty_activity[0].isNew);
    let isEdit = this.props.isEdit || workday.dutyActivityStatus == "N" ||isOFFDay;
    function itemFilter(item) {
      return {
        key: item.id,
        value: item.name,
        label: item.name
      };
    }
    let dutyActivities = workday.duty_activity.filter((a) => !a.isDeleted);
    let isCoveredService = dutyActivities.filter(act => constants.HOS_COVERED_SERVICE.indexOf(act.dty_act_name.trim()) > -1).length > 0;
    let prevDays = this.state.prevDutyTimeOffDays;
    return (
      <div>
        {
          this.renderWorkdayDetails()
        }
        <Table className="mainTblHead LogTable table-bordered table-condensed">
          <Thead>
            <Tr>
              <Th className="header activityName">Activity</Th>
              <Th className="header activityName">Value</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td className="">Job Symbol</Td>
              {isEdit ? 
                <Td>
                  <input type='text' value = {workday.wdy_job_symbol} 
                    onChange = {(e) => {this.workdayActChange("wdy_job_symbol",e.target.value)}} />
                </Td>
                :
                <Td className="">{workday.wdy_job_symbol}</Td>}
            </Tr>
            <Tr>
              <Td className="">Occupation</Td>
              {
                isEdit ? 
                <Td>
                  <Select unselected={{
                    value: "",
                    label: "--Select Type--"
                  }}
                  items={constants.logTypes.OCCUPATION} itemFilter={itemFilter}
                  value={workday.job_class.trim()}
                  onChange = {(e) => {this.workdayActChange("job_class",e.target.value)}} /> 
                </Td>
                :
                <Td className=""> {workday.job_class} </Td>
              }
              
            </Tr>
            <Tr>
              <Td className="">Duty Type</Td>
              {
                isEdit ? 
                <Td>
                  <Select unselected={{
                    value: "",
                    label: "--Select Type--"
                  }}
                  items={constants.logTypes.DUTY_TYPE} itemFilter={itemFilter}                  
                  value={workday.job_type}
                  onChange = {(e) => {this.workdayActChange("job_type",e.target.value)}} /> 
                </Td>
                :
                <Td className=""> {isCoveredService.toString().trim()==='false'? constants.logTypes.DUTY_TYPE[2].name:workday.job_type} </Td>
              }
            </Tr>
            <Tr>
              <Td className="">Prev. Time Off Duty</Td>
              {isEdit ? 
                <Td>
                    <div className={ this.state.prevTimeOffError.length > 0 ?"reqFieldErr":"hidden"}>
                {this.state.prevTimeOffError}
                  </div> 
                  <input type='number' maxlength="3" name ="inputDays"  className="width16" value={this.getPreviousTimeOFDutyValue("inputDays")}  onChange={(e) => {this.handlePrevTime(e.target.name,e.target.value)} }  onBlur = {(e) => {this.prevTimeOnChange(e)}}/> D 
                  <input type='number' maxlength="2" name ="inputHours"  className="width16" value ={this.getPreviousTimeOFDutyValue("inputHours")} onChange={(e) => {this.handlePrevTime(e.target.name,e.target.value)} } onBlur={(e) => {this.prevTimeOnChange(e)} } /> H 
                  <input type='number' maxlength="2" name ="inputMinutes"  className="width16" value = {this.getPreviousTimeOFDutyValue("inputMinutes")} onChange = {(e) => {this.handlePrevTime(e.target.name,e.target.value)}}  onBlur={(e) => {this.prevTimeOnChange(e)} }/> M 
                </Td>
                :
                <Td className=""> {workday.previous_Time_Off_Duty && workday.previous_Time_Off_Duty.length > 0?this.showPreviousTimeOffDuty(workday):  this.getPrevTimeOffDuty(workday)} </Td>   
              }
               


             
            </Tr>
            <Tr>
              <Td className="">6 Day Series</Td>
              {isEdit ? 
                <Td>
                  <input type='text' value = {workday.dty_act_series_6} 
                    onChange = {(e) => {this.workdayActChange("dty_act_series_6",e.target.value)}} />
                </Td>
                :
                <Td className="">{workday.dty_act_series_6}</Td>}
            </Tr>
            <Tr>
              <Td className="">14 Day Series</Td>
              {isEdit ? 
                <Td>
                  <input type='text' value = {workday.dty_act_series_14} 
                    onChange = {(e) => {this.workdayActChange("dty_act_series_14",e.target.value)}} />
                </Td>
                :
                <Td className="">{workday.dty_act_series_14}</Td>}
            </Tr>
            <Tr>
              <Td className="">Previous date not initiating Covered Service</Td>
              <Td className=""> {workday.previous_Non_CoveredService_date} </Td>
            </Tr>
          </Tbody>
        </Table>
      </div>
    );
  }

  renderCommentsSectionLogs(comment = ''){
    let comment_modified = '';
    if(comment)
    {
      comment = comment.split('~');
      comment = comment.map(str => str.replace('^', ''));
      comment = comment.map(str => str.replace('~', ''));
      comment = comment.map(str => str.trim());
      comment_modified = comment.join("\n");
      comment_modified = comment_modified.trim() == 'NULL' ? comment_modified.replace('NULL', '') : comment_modified;
    }   
    var workday = this.props.isFRAReport? this.props.defaultWorkday: this.props.workday.workday;
    if(!workday.duty_activity || !Array.isArray(workday.duty_activity) || workday.duty_activity.length == 0){
      if(comment_modified.length >  0) {
        return (
          <div className='hosloglabel'>
            <div className = {comment_modified ? "" : "hidden"}>
              <span>Comments</span>
              <textarea className = 'commentuser' rows="4"  value={comment_modified} />
            </div>
          </div>
        )
      }
      return null;
    } 
    let dutyActivity = workday.duty_activity.filter((act) =>!act.isDeleted);
    let updatedendTime ='';
    if(dutyActivity && dutyActivity.length>0)
    {
    updatedendTime = dutyActivity[dutyActivity.length-1].dty_act_end_time_updated ? 
                              dutyActivity[dutyActivity.length-1].dty_act_end_time_updated : 
                              dutyActivity[dutyActivity.length-1].dty_act_end_time;
    updatedendTime = updatedendTime ? updatedendTime : '12:00 am';
    }
    let finalRelease = workday.duty_activity && workday.duty_activity.filter((act) =>!act.isDeleted).length > 0 ? moment(updatedendTime,"hh:mm A").format('hh:mm A') : '';
    let totalTimeonDuty = workday.wdy_working_time_hos_adjust ? workday.wdy_working_time_hos_adjust : workday.wdy_working_time_hos ;
    let signon = workday.duty_activity.filter((act) => !act.dty_act_name.includes("Deadhead") && !act.isDeleted && !act.dty_act_name.toLowerCase().includes("limbo"));
    let signonupdatedtime = signon && signon.length > 0 ? signon[signon.length-1].dty_act_end_time_updated ? signon[signon.length-1].dty_act_end_time_updated : signon[signon.length-1].dty_act_end_time : '12:00 am';
    signonupdatedtime = signonupdatedtime ? signonupdatedtime : '12:00 am';
    let releivedOfDuty = signon && signon.length > 0 ? moment(signonupdatedtime, "hh:mm A").format('hh:mm A') : '';

  
    let is_cs = false;
      let activities = workday.duty_activity;
      //check for loading of activity first time and before save
      let doNotShowTimeCalc = workday.IsAmendment == '0' && (workday.wdy_certify_status.trim().toUpperCase() == 'U')
          && workday.AllowAmendmentEdit == undefined ;

    for(var i = 0; i< activities.length; i++){
      let act_name = activities[i].dty_act_name_updated?activities[i].dty_act_name_updated.trim():activities[i].dty_act_name.trim();
      if(constants.COVERED_SERVIE.indexOf(act_name) > -1 || act_name == 'Sign-on'){
        is_cs = true;
        break;
      }
    }

   let totalhrs = Number(totalTimeonDuty.split('h')[0] * 60) + Number(totalTimeonDuty.split('h')[1]);
   if(totalhrs > 1200)
   {
     
   let err = `Your total time on duty exceeds 20 hours. Please check your record and make sure you entered the correct dates and times.`;
   this.props.onActErr(true, true,err);
   }


    return (
      <div className='hosloglabel'>
        <div className = {comment_modified ? "" : "hidden"}>
          <span>Comments</span>
          <textarea className = 'commentuser' rows="4"  value={comment_modified} />
        </div>
        <div className="center">
                <span className={is_cs ? '' : 'hidden'} >Relieved of Duty : {doNotShowTimeCalc && !this.showtotalHOS?"": this.showRelievedOfDuty(workday,releivedOfDuty)}</span><br />                
                <span className={is_cs ? '' : 'hidden'} >Final release : {doNotShowTimeCalc && !this.showtotalHOS? "":this.showfinalRelease(workday,finalRelease)}</span><br />
                <span>Total Time on Duty : {doNotShowTimeCalc && !this.showtotalHOS ? "":this.showtotalTimeonDuty(workday,totalTimeonDuty)}</span>                  
               
        </div>
      </div>
    )
    }

   
  render() {
    return (
      <ActivitiesComp scrollContainer={el => {
        this.scrollContainer = el;
      }} renderActivities={this.renderActivities.bind(this)}
        renderAddButton={this.renderAddButton.bind(this)}
        renderWorkdayDetails={this.renderWorkdayDetails.bind(this)}
        role={this.props.authDetails.role} defaultWorkday={this.props.defaultWorkday}
        certifyStatus={this.props.certifyStatus ? this.props.certifyStatus : this.state.workday.workday.wdy_certify_status}       
        adjustedHOS={this.props.adjustedHOS} renderLogs={this.renderLogs.bind(this)}
        renderCommentBox={this.renderCommentBox.bind(this)} comments={this.state.workday.workday.wdy_comments}
        eventKey={this.props.eventKey} 
        isLogUser = {this.props.isLogUser}
        isEdit = {this.props.isEdit}
        isFRAReport={this.props.isFRAReport}
        impersonateUserId={this.props.authDetails.impersonateUserId}
        renderWorkDayActLogs = {this.renderWorkDayActLogs.bind(this)}
        renderCommentsSectionLogs = {this.renderCommentsSectionLogs.bind(this)}
        showAction={this.props.modalName == "Certify_Modal" || this.props.addingWorkday ? true : false}
        claimStatus = {this.state.workday.workday.wdy_claim_status}
            deadheadWarning={this.props.deadheadWarning} deadheadMessage={this.props.deadheadMessage}
            workday={this.props.workday}    
      />
    );
  }
}

function mapStateToProps(state) {
  // coming from store
  return {
    workday: state.workday,
    modalName: state.modals.modalName,
    role: state.role,
    dbActivities: state.workdays.activities,
    activityErr: state.modals.activityErr,
    authDetails: state.authState,
    changesInActivity: state.modals.changesInActivity,
    deadheadWarning:state.modals.deadheadWarning,
    deadheadMessage:state.modals.deadheadMessage
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      loadingWorkday:loadingWorkdayAction,
      onChangesInActivity: changesInActivityAction,
      onAddActivity: addActivityAction,
      onEditActivity: editActivityAction,
      onDeleteActivity: deleteActivityAction,
      onChangeActivity: changeActivityAction,
      onActErr: actErrorAction,
      setActivityErr: setActivityErrAction,
      changeWorkdayActivityLogs : changeWorkdayActivityLogs,
      setDeadheadWarningAction:setDeadheadWarningAction
    },
    dispatch
  );
}
export { Activities };

export default connect(mapStateToProps, matchDispatchToProps)(Activities);
